export enum AUTH_KEYS {
  ADMIN_TOKEN = 'rhp_admin_auth_token',
  ADMIN_SESSION = 'rhp_admin_session',
  USER_PERMISSION_TYPE = 'rhp_user_permission',
  USER_ACCOUNT_TYPE = 'rhp_account_type',
  USER_PERMISSION = 'rhp_permission',
  RESET_PASSWORD_SESSION = 'rhp_reset_password_session',
}
